import React, {useState} from "react";
import HeaderMenu from "./HeaderMenu";
import {StaticImage} from "gatsby-plugin-image";
import {Link} from "gatsby";

const Header: React.FC = () => {

    const [state, setState] = useState({
        menuVisible: false
    });

    const toggleMenuVisibility = () => {
        setState({
            ...state,
            menuVisible: !state.menuVisible
        });
    }

    const hideMenu = () => {
        setState({
            ...state,
            menuVisible: false
        });
    }

    return (
        <header id="header">
            <div
                className={`tham tham-e-squeeze tham-w-10 absolute right-0 top-0 mr-4 mt-3 z-50 xl:hidden ${state.menuVisible ? 'tham-active' : ''}`}
                onClick={toggleMenuVisibility}>
                <div className="tham-box">
                    {/* @todo create PR for tailwind-hamburger to inherit border radius */}
                    <div
                        className="tham-inner h-1 before:h-1 after:h-1 rounded-none before:rounded-none after:rounded-none bg-white"/>
                </div>
            </div>
            <div
                className="container relative triangle after:z-10 after:border-[15px] after:absolute after:block after:right-0 md:after:right-4 after:top-0 after:border-t-darkgrey after:border-r-darkgrey after:border-b-lightgrey after:border-l-lightgrey">
                <div id="logo" className="p-4 md:p-0 w-full bg-white md:h-40 xl:h-44 flex items-center justify-center">
                    <Link to={'/'} title={'zur Startseite'}>
                        <StaticImage src={'../assets/images/Logo_Thomas_Reiser.png'}
                                     alt={'Kanzlei Reiser Logo'}
                                     width={640}
                                     loading={'eager'}
                                     imgStyle={{
                                         transition: 'none',
                                         opacity: 1
                                     }}
                                     placeholder={'none'}
                        >
                        </StaticImage>
                    </Link>
                </div>
                <div className="h-4 w-full bg-red xl:hidden">

                </div>
                <nav className={`${state.menuVisible ? 'visible' : 'invisible'} xl:visible`}>
                    <HeaderMenu onMenuLinkChange={hideMenu} menuVisible={state.menuVisible}></HeaderMenu>
                </nav>
            </div>
        </header>
    );
};

export default Header;
